import { useEffect, useState } from "react";

import TrackingLogic from "@/src/logic/TrackingLogic";

const useLinkWithTrackingParams = (pathAndQuery: string, active: boolean = false) => {
  const [utmParams, setUTMParams] = useState<any>(undefined);

  useEffect(() => {
    const defaultParams = {
      utmSource: (window.location.hostname ?? "").replaceAll(".", "_"),
      utmMedium: "organic",
      utmCampaign: "default_direct_traffic",
    };
    const params = TrackingLogic.getUTMParams();
    const toSetParams = params?.utmSource || params?.utmMedium ? params : defaultParams;
    setUTMParams(toSetParams);
  }, []);

  return active ? TrackingLogic.carryUTMParams(pathAndQuery, true, utmParams) : pathAndQuery;
};

export default useLinkWithTrackingParams;
